import * as React from "react";
import { Switch } from "react-router-dom";
import Account_Index from "./components/account/Index";
import Account_Logout from "./components/account/Logout";
import Account_Settings from "./components/account/Settings";
import Unauthorized from "./components/account/Unauthorized";
import RouteWithLayout from "./components/common/RouteWithLayout";
import Customers_Index from "./components/customers/Index";
import Customers_IndexTab from "./components/customers/Index-Tab";
import Customers_IndexBqs from "./components/customers/Index-BQS";
import Customers_IndexBc from "./components/customers/Index-BC";
import Customers_Add from "./components/customers/Add";
import Customers_Edit from "./components/customers/Edit";
import Customers_View from "./components/customers/View";
import Home from "./components/Home";
import Products_Index from "./components/products/Index";
import Products_View from "./components/products/View";
import Jobs_Add from "./components/Projects/Add";
import Jobs_Edit from "./components/Projects/Edit";
import Jobs_IndexBc from "./components/Projects/Index-BC";
/*import Jobs_Index from "./components/Projects/Index";*/
import Jobs_IndexBqs from "./components/Projects/Index-BQS";
import Jobs_ViewBc from "./components/Projects/view-BC";
import Jobs_ViewBqs from "./components/Projects/view-BQS";
import Quotes_Add from "./components/quotes/Add";
import Quotes_Edit from "./components/quotes/Edit";
import Quotes_Index from "./components/quotes/Index";
import Quotes_SalesOrder from "./components/quotes/SalesOrder";
import Quotes_View from "./components/quotes/View";
import Quotes_ViewHistory from "./components/quotes/ViewHistory";
import Reports_Index from "./components/reports/Index";
import Reports_Products from "./components/reports/Products";
import Reports_Quotes from "./components/reports/Quotes";
import Search_Index from "./components/search/Index";
import Section from "./components/sections/Index";
import Section_View from "./components/sections/View";
import Settings_Index from "./components/settings/index";
import Settings_Tax from "./components/settings/Tax";
import Users_Add from "./components/users/Add";
import Users_Edit from "./components/users/Edit";
import Users_Index from "./components/users/Index";
import Vendor from "./components/vendors/Index";
import Vendor_View from "./components/vendors/View";
import Kits_Index from "./components/kits/Index";
import Kits_View from "./components/kits/View";
import Settings_LogsPage from "./components/settings/LogsPage";

export const routes = (
    <>
        <RouteWithLayout exact path="/" component={Home} />
        <RouteWithLayout exact path="/account/unauthorized" component={Unauthorized} />
        <RouteWithLayout exact path="/account" component={Account_Index} />
        <RouteWithLayout
            exact
            path="/account/settings"
            component={Account_Settings}
        />
        <RouteWithLayout exact path="/account/logout" component={Account_Logout} />
        <Switch>
            <RouteWithLayout exact path="/customers-bqs" component={Customers_IndexBqs} />
            <RouteWithLayout exact path="/customers/add" component={Customers_Add} />
            <RouteWithLayout exact path="/customers/edit/:id" component={Customers_Edit} />
            <RouteWithLayout exact path="/customers/:id" component={Customers_View} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/customers-bc" component={Customers_IndexBc} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/jobs-bqs" component={Jobs_IndexBqs} />
            <RouteWithLayout exact path="/jobs/add" component={Jobs_Add} />
            <RouteWithLayout exact path="/jobs/edit/:id" component={Jobs_Edit} />
            <RouteWithLayout exact path="/jobs-bqs/:id" component={Jobs_ViewBqs} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/jobs-bc" component={Jobs_IndexBc} />
            <RouteWithLayout exact path="/jobs-bc/:id" component={Jobs_ViewBc} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/kits" component={Kits_Index} />
            <RouteWithLayout exact path="/kits/:id" component={Kits_View} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/products" component={Products_Index} />
            <RouteWithLayout exact path="/products/:id" component={Products_View} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/sections" component={Section} />
            <RouteWithLayout exact path="/sections/:id" component={Section_View} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/vendors" component={Vendor} />
            <RouteWithLayout exact path="/vendors/:id" component={Vendor_View} />
        </Switch>
        <Switch>
            <RouteWithLayout exact path="/quotes" component={Quotes_Index} />
            <RouteWithLayout exact path="/quotes/add" component={Quotes_Add} />
            <RouteWithLayout exact path="/quotes/edit/:id" component={Quotes_Edit} />
            <RouteWithLayout
                exact
                path="/quotes/history/:id"
                component={Quotes_ViewHistory}
            />
            <RouteWithLayout exact path="/quotes/:id" component={Quotes_View} />
            <RouteWithLayout
                exact
                path="/quotes/salesorder/:quoteId"
                component={Quotes_SalesOrder}
            />
            <RouteWithLayout
                exact
                path="/quotes/salesorder/:quoteId/:orderId"
                component={Quotes_SalesOrder}
            />
        </Switch>
        <RouteWithLayout exact path="/reports" component={Reports_Index} />
        <RouteWithLayout
            exact
            path="/reports/products"
            component={Reports_Products}
        />
        <RouteWithLayout exact path="/reports/quotes" component={Reports_Quotes} />
        <Switch>
            <RouteWithLayout exact path="/search" component={Search_Index} />
            <RouteWithLayout exact path="/search/:query" component={Search_Index} />
        </Switch>
        <RouteWithLayout exact path="/settings" component={Settings_Index} />
        <RouteWithLayout exact path="/settings/tax" component={Settings_Tax} />
        <RouteWithLayout exact path="/settings/logs" component={Settings_LogsPage} />
        <Switch>
            <RouteWithLayout exact path="/users" component={Users_Index} />
            <RouteWithLayout exact path="/users/add" component={Users_Add} />
            <RouteWithLayout exact path="/users/edit/:id" component={Users_Edit} />
        </Switch>

    </>
);



// WEBPACK FOOTER //
// ./ClientApp/routes.tsx